import { call, put } from 'redux-saga/effects';
import { requestGetDepartmentByUser, requestGetDepartments, requestGetDepartment, requestCreateDepartment, requestUpdateDepartment, requestAddUsersToDepartment, requestRemoveUsersFromDepartment, requestDeleteDepartment } from '../requests/departments';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

/** GET /by-user returns a single department doc, null, or (legacy) []. Never treat arbitrary arrays as a department. */
function normalizeDepartmentByUserResponse(data) {
    if (data == null) {
        return {};
    }
    if (Array.isArray(data)) {
        if (data.length !== 1) {
            return {};
        }
        const one = data[0];
        return one && typeof one === 'object' && one.name ? one : {};
    }
    if (typeof data === 'object' && data.name) {
        return data;
    }
    return {};
}

export function* handleGetDepartments(action) {
    const { start, limit, callback } = action.payload;
    try {
        const response = yield call(requestGetDepartments, start, limit);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleGetDepartment(action) {
    const { id, callback } = action.payload;
    try {
        const response = yield call(requestGetDepartment, id);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleGetDepartmentByUser(action) {
    const { userId, callback } = action.payload;
    try {
        const response = yield call(requestGetDepartmentByUser, userId);
        if (callback) {
            callback(normalizeDepartmentByUserResponse(response.data));
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback({});
        }
    }
}

export function* handleCreateDepartment(action) {
    const { department, callback } = action.payload;
    try {
        const response = yield call(requestCreateDepartment, department);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleUpdateDepartment(action) {
    const { id, department, callback } = action.payload;
    try {
        const response = yield call(requestUpdateDepartment, id, department);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleAddUsersToDepartment(action) {
    const { id, users, callback } = action.payload;
    try {
        const response = yield call(requestAddUsersToDepartment, id, users);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleRemoveUsersFromDepartment(action) {
    const { id, users, callback } = action.payload;
    try {
        const response = yield call(requestRemoveUsersFromDepartment, id, users);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleDeleteDepartment(action) {
    const { id, callback } = action.payload;
    try {
        const response = yield call(requestDeleteDepartment, id);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}